export default __webpack_public_path__ + "media/images/svg/vr-07ac863cd6723b088a38f752796f2d10.svg";